<template>
    <section class="tms-performance-dialog-wrapper">
        <el-dialog :visible.sync="dialogVisible"
                   :append-to-body="true"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :destroy-on-close="true"
                   :width="width"
                   :before-close="handleClose"
                   custom-class="tms-performance-dialog">
            <template #title>
                <span class="dialog-title">{{ title }}</span>
                <span class="addition-info">{{ additionInfo }}</span>
            </template>
            <section class="main-container"
                     v-loading="loading">
                <div class="main-base-info">
                    <slot name="top"></slot>
                </div>
                <div class="main-list-info">
                    <slot name="table-list"></slot>
                </div>
            </section>
        </el-dialog>
    </section>
</template>

<script>
export default {
    name: 'PerformanceCommonDialog',
    props: {
        title: {
            type: String,
            default: ''
        },
        width: {
            type: String,
            default: '70%'
        },
        additionInfo: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            dialogVisible: false,
            loading: false
        };
    },
    methods: {
        handleClose () {
            this.$emit('close');
            this.dialogVisible = false;
        },
        show () {
            this.dialogVisible = true;
        },
        showLoading () {
            this.loading = true;
        },
        hideLoading () {
            this.loading = false;
        }
    }
};
</script>
<style lang="less">
.tms-performance-dialog {
    .dialog-title {
        margin-right: 24px;
    }
    .addition-info {
        color: #00bcbf;
    }
    .main-list-info {
        margin-top: 16px;
        padding-top: 12px;
        border-top: 1px dashed hsla(0, 0%, 87.5%, 0.8);
    }
    .main-base-info {
        .el-form-item__label {
            color: #999 !important;
        }
        .el-form-item__content {
            color: #333;
        }
    }
}
</style>
